import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Fornecedores',
    path: '/commercial/providers',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
